/**
 * @param {string} title              - The title header
 * @param {array} children            - Child JSX componets
 *
 * @returns {JSX.Element} 				    - The property type component.
 */
export default function Section({ children, title = '' }) {
  return (
    <section className="flex flex-col gap-6">
      <h1 className="m-auto w-full text-2xl font-bold md:px-4 lg:w-3/5">{title}</h1>
      <div className="m-auto flex w-full flex-col gap-4 md:px-4 lg:w-3/5 ">{children}</div>
    </section>
  );
}
